import { FluxStandardAction } from 'flux-standard-action'
import {
  GET_PATIENT_DETAILS,
  GET_PATIENT_SHARED,
  PUT_PATIENT_SHARED,
} from '../constants/patient.constant'
export interface Options {
  patientId: string
  jwtToken: string
}
export interface PutPatientSharedOptions extends Options {
  enable: boolean
  password: string
}
export const getPatientDetails = (
  options: Options
): FluxStandardAction<any, any> => ({
  type: GET_PATIENT_DETAILS,
  payload: options,
  meta: null,
})

export const getPatientShared = (
  options: Options
): FluxStandardAction<any, any> => ({
  type: GET_PATIENT_SHARED,
  payload: options,
  meta: null,
})

export const putPatientShared = (
  options: PutPatientSharedOptions
): FluxStandardAction<any, any> => ({
  type: PUT_PATIENT_SHARED,
  payload: options,
  meta: null,
})



// WEBPACK FOOTER //
// ./src/actions/patient.action.ts